import Vue from 'vue'
import { Button, Tabbar, TabbarItem, DropdownMenu, DropdownItem, Field, Divider, Search, Cell, CellGroup, Icon, Form, Calendar, Tab, Tabs, DatetimePicker, Popup, Lazyload, List, PullRefresh, Switch, NavBar} from 'vant'

Vue.use(Button)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Field)
Vue.use(Divider)
Vue.use(Search)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Icon)
Vue.use(Form)
Vue.use(Calendar)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Lazyload,{error:'https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=4111730558,764969898&fm=26&gp=0.jpg'})
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Switch)
Vue.use(NavBar)
